var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"wrap nav"},[_c('div',{staticClass:"left",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{staticClass:"img",attrs:{"src":require("../assets/new_logo.png")}})]),_c('div',{staticClass:"right"},[_c('ul',{on:{"click":_vm.onClick}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }